import { useParams, useMatch } from 'react-router-dom'
import { parseAsString, useQueryState } from 'nuqs'

import { capitalize } from '~publish/helpers/capitalize'
import {
  allChannels,
  tagTab,
  profileTabPages,
  channel,
} from '~publish/legacy/routes'

export const useNotesCtaView = (): string => {
  const { tabId, tab } = useParams<{
    tabId?: string
    tab?: string
  }>()
  // Read-only view of the same `tab` param AllChannelsPage/ChannelPage own —
  // both write it as a bare scalar, so this reads correctly regardless of
  // which hook wrote it.
  const [queryTab] = useQueryState('tab', parseAsString)
  const isAllChannelsPage = !!useMatch(allChannels.route)
  const isChannelPage = !!useMatch(channel.route)
  const isTagsPage = useMatch(tagTab.route)
  const isProfilePage = !!useMatch(profileTabPages.route)

  if (isAllChannelsPage) {
    return `allChannels${capitalize(queryTab || 'queue')}`
  }

  if (isChannelPage) {
    return `channel${capitalize(queryTab || 'queue')}`
  }

  if (isTagsPage && tab) {
    return `tags${capitalize(tab)}`
  }

  if (isProfilePage && tabId) {
    return `profile${capitalize(tabId)}`
  }

  return 'unknown'
}
